import React, { Component, Fragment } from "react";
import Chart from "react-apexcharts";
import Select from "./Select";

export default class Grafico extends Component {

    constructor(props) {
        super(props);

        this.state = {
            mes: "Anual",
            metas: [],
            dados: [],
            realizados: [],
            acumulado: {},
            isAcumulado: false,
            modalidade: "Consultoria em Tecnologia",
            unidade: "DR",
            nomeCampo: "horasTecnicas",
            selectUnidade: "DR",
            selectModalidade: "Consultoria em Tecnologia",
            selectMetaRealizado: "metasrealizados",
            selectCampo: "horasTecnicas",
            series: new Array(10).fill(15),
            options: {

                chart: {
                    height: 350,
                    type: 'line',
                    toolbar: {
                        show: false
                    },
                },

                colors: ['#77B6EA', '#545454', '#FEBC3B', "#51CBCE"],

                plotOptions: {
                    bar: {
                      dataLabels: {
                        position: 'top',
                      },
                    }
                },

                dataLabels: {
                    enabled: true,
                    formatter: function (value) {
                        return value.toLocaleString("pt-BR", { maximumFractionDigits: 2, style: 'decimal' });
                    },
                    style: {
                        fontSize: '13px',
                        fontFamily: 'Helvetica, Arial, sans-serif',
                        fontWeight: 'bold',
                        colors: ["#304758"]
                    },
                    offsetY: -20
                },

                stroke: {
                    curve: 'smooth'
                },

                title: {
                    text: 'Total',
                    align: 'left'
                },

                grid: {
                    borderColor: '#e7e7e7',
                    row: {
                        colors: ['#f3f3f3', 'transparent'],
                        opacity: 0.5
                    },
                },

                markers: {
                    size: 1
                },

                xaxis: {
                    categories: ["JAN", "FEV", "MAR", "ABR", "MAI", "JUN", "JUL", "AGO", "SET", "OUT", "NOV", "DEZ"],
                    title: {
                        text: 'Mês'
                    }
                },

                yaxis: {
                    title: {
                        text: 'TOTAL'
                    },
                    //min: 5,
                    //max: 40,
                    //opposite: true,
                    labels: {
                        formatter: function (value) {
                            if (Number.isFinite(value)) {
                                return value.toLocaleString("pt-BR", { maximumFractionDigits: 2, style: 'decimal' });
                            }
                            else {
                                return 0
                            }
                        }
                    }
                },
                legend: {
                    position: 'top',
                    horizontalAlign: 'right',
                    floating: true,
                    offsetY: -25,
                    offsetX: -5,
                    formatter: function(seriesName, opts) {
                        seriesName = seriesName === "Total" ? "Total" : seriesName;
                        return [seriesName]
                    }
                }
            
            }

        }
    }

async componentDidMount() {
    this.calculaTipoPorMes();
}

async componentDidUpdate(prevProps, prevState) {
    if(this.props.mesSelecionado !== prevProps.mesSelecionado || this.props.metas !== prevProps.metas) {
        this.calculaTipoPorMes();
    }
}

calculaTipoPorMes = async (event) => {

    let valor = event ? event.target.value : null;
    let id = event ? event.target.id : null;

    let { selectUnidade, selectModalidade, selectMetaRealizado, selectCampo, isAcumulado } = this.state;

    if(id === "isAcumulado") {
        if(valor === "mensal") isAcumulado = false;
        if(valor === "acumulado") isAcumulado = true;
    }

    let { metas, realizados, acumulado } = this.props;

    if (id === "selectUnidade") {
        selectUnidade = valor;
    }
    if (id === "selectModalidade") {
        selectModalidade = valor;
    }
    if (id === "selectMetaRealizado") {
        selectMetaRealizado = valor;
    }
    if (id === "selectCampo") {
        selectCampo = valor;
    }

    let indice = metas && metas.findIndex(unidade => unidade.unidade === selectUnidade);
    let indiceRealizado = realizados && realizados.findIndex(unidade => unidade.unidade === selectUnidade);

    let metaSelect = new Array(12).fill(0);
    let realizadoSelect = new Array(12).fill(0);

    let stateSeries = [
        {
            name: "Metas",
            data: metaSelect
        },
        {
            name: "Realizados",
            data: realizadoSelect
        }
    ];

    try {
        metaSelect = metas[indice]["modalidades"][selectModalidade][selectCampo]
        realizadoSelect = realizados[indiceRealizado]["modalidades"][selectModalidade][selectCampo]

        stateSeries[0].data = metaSelect;
        stateSeries[1].data = realizadoSelect;
    } catch (error) {
    }

    switch(selectMetaRealizado) {
        case "metas":
            stateSeries.splice(1, 1);
            break;
        case "realizados":
            stateSeries.splice(0, 1);
            break;
    }

    this.setState({
        series: stateSeries,
        options: {
            title: {
                text: `${selectUnidade}`
            }
        },
        selectUnidade,
        selectModalidade,
        selectMetaRealizado,
        selectCampo,
    });

}

formataColuna = (coluna) => {
    switch(coluna) {
        case "calibracoes":
            coluna = "Calibrações"
            break;
        case "ensaios":
            coluna = "Ensaios"
            break;
        case "horasTecnicas":
            coluna = "Horas Técnicas"
            break;
        case "numeroAtendimento":
            coluna = "Número de Atendimento"
            break;
        case "relatoriosELaudos":
            coluna = "Relatórios/Laudos"
            break;
        case "receita":
            coluna = "Receita"
            break;
        case "despesa":
            coluna = "Despesa"
            break;
    }
    return coluna;
}

render() {
    let { selectCampo, selectModalidade, options, series } = this.state;
    return (
        <Fragment>

            <div className="row">
                <div className="col-md-12">
                    <div className="card ">
                        <div className="card-header ">
                            <div className="row">
                                <div className="col-md-6">
                                    <h5 className="card-title">{this.formataColuna(selectCampo)}</h5>
                                    <h6>{selectModalidade}</h6>
                                </div>
                                {/* <div className="col-md-2">
                                    <Select select={null} campo="visao" idComponente="isAcumulado" />
                                </div> */}
                                <div className="col-md-2">
                                    <Select select={this.calculaTipoPorMes} campo="campos" idComponente="selectCampo" />
                                </div>
                                <div className="col-md-2">
                                    <Select select={this.calculaTipoPorMes} campo="unidades" idComponente="selectUnidade" />
                                </div>
                                <div className="col-md-2">
                                    <Select select={this.calculaTipoPorMes} />
                                </div>
                            </div>
                        </div>
                        <div className="card-body ">
                            <div className="mixed-chart">
                                <Chart options={options} series={series} type="bar" height={"300"} />
                            </div>
                        </div>
                        <div className="card-footer ">
                            <hr />
                            <div className="stats">
                                <i className="fa fa-history"></i> {new Date().toLocaleDateString("pt-br", { dateStyle: "full" })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </Fragment>
    )
}
}